const HourglassHalf = ({ color, width, className }) => {
    return <svg id="hourglass_top_black_24dp" xmlns="http://www.w3.org/2000/svg" width={width} height={width} class={`MuiSvgIcon-root ${className}`} viewBox="0 0 24 24">
        <g id="Groupe_2792" data-name="Groupe 2792">
            <rect id="Rectangle_3433" data-name="Rectangle 3433" width={width} height={width} fill="none" />
            <rect id="Rectangle_3434" data-name="Rectangle 3434" width={width} height={width} fill="none" />
        </g>
        <g id="Groupe_2793" data-name="Groupe 2793">
            <path id="Tracé_14035" data-name="Tracé 14035" d="M8,2A2.006,2.006,0,0,0,6,4l.01,3.18a2.016,2.016,0,0,0,.58,1.41L10,12,6.59,15.43a2,2,0,0,0-.58,1.41L6,20a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V16.84a2,2,0,0,0-.58-1.41L14,12l3.41-3.4A2.006,2.006,0,0,0,18,7.18V4a2.006,2.006,0,0,0-2-2Zm8,14.91V19a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V16.91a1.033,1.033,0,0,1,.29-.71L12,12.5l3.71,3.71A1.009,1.009,0,0,1,16,16.91Z" fill={color} />
        </g>
    </svg>
}

export default HourglassHalf